"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * NOTE(alipianu): manually pulled this icon from https://www.figma.com/design/qcB5qVN7uKBBYHN49ihDE7/Slate-Icons?node-id=7297-413&t=I0tqvo8Q4Skk0xE3-0
 * TODO: manually sync and consolidate all Faire Logo icons into a new `/slate/icons/faire-logos directory, update icon CLI commands support syncing this and all other Faire Logo icons
 * @trackcomponent
 */
export const VolumeBasedDiscounts = createSVGIcon(
  <path d="M0 20V0H16V20L8 15L0 20Z" fill="#5A1E09" />,
  "VolumeBasedDiscounts",
  {
    viewBox: "0 0 16 20",
    fill: "none",
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
